import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CoreService } from '../../../_services/core.service';
import { FlowsheetService } from '../../../_services/flowsheet.service';
import { SuncorMaterialStream } from '../../../_models';
import { StreamCompositionType } from '../../../_config/stream-composition-type.enum';
import { UnitSubset } from '../../../_config/unitSubset.enum';

@Component({
  selector: 'sob-material-stream',
  templateUrl: './material-stream.component.html',
  styleUrls: ['./material-stream.component.css'],
})
export class MaterialStreamComponent implements OnInit {
  stream: SuncorMaterialStream;
  streamGroup: UntypedFormGroup;
  compositionTypeSelected: string = StreamCompositionType.MASS;
  protected readonly StreamCompositionType = StreamCompositionType;
  protected readonly UnitSubset = UnitSubset;

  constructor(
    private coreService: CoreService,
    private flowsheetService: FlowsheetService,
    private ref: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    this.flowsheetService.openStreamPropertyWindowRequest.subscribe(streamId => {
      this.openStream(streamId);
    });
  }

  initForm() {
    this.streamGroup = this.fb.group({
      name: this.fb.control(this.stream.name || '', [Validators.required, this.uniqueNameValidator()]),
    });
  }

  get nameControl() {
    return this.streamGroup ? (this.streamGroup.get('name') as UntypedFormControl) : null;
  }

  ngOnInit() {
    // should this init empty?
    this.streamGroup = this.fb.group({ name: this.fb.control('') });

    $('#streamModal').on('hide.bs.modal', e => {
      if (this.streamGroup.invalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.nameControl.markAsDirty();
        return false;
      }

      this.save();
      return true;
    });
  }

  openStream(streamId) {
    this.stream = null;
    this.ref.detectChanges();
    this.stream = this.coreService.currentCase.filterSuncorMaterialStreams(stream => {
      return stream.id === streamId;
    })[0];

    this.initForm();
    this.ref.detectChanges();

    $('#streamModal').modal('show');
  }

  save() {
    this.stream.name = this.nameControl.value.trim();
    this.coreService.saveStream(this.stream);
  }

  uniqueNameValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (
        this.stream.ownerCase.filterSuncorMaterialStreams(
          s => s.name === control.value.trim() && s.id !== this.stream.id
        ).length
      ) {
        return { unique: true };
      }
      return null;
    };
  }

  compositionTypeChanged(target: EventTarget | null) {
    this.compositionTypeSelected = (target as HTMLButtonElement).name;
  }
}
